import request from "./axios.js";

const api = {};
// 常见问题图片
api.getTeachTopPics = (params = {}) => request({ url: "teach/teachTopPics", method: "post", data: params });
// 常见问题列表
api.getTeachCommonList = (params = {}) => request({ url: "teach/teachCommonList", method: "post", data: params });
// 常见问题详情
api.getAnswerDetails = (params = {}) => request({ url: "teach/answerDetails", method: "post", data: params });
// / 教程答疑常见问题菜单（H5）
api.getTeachPlateList = (params = {}) => request({ url: "teach/teachPlateList", method: "post", data: params });
// 答疑列表（移动端）
api.getTeachCenterList = (params = {}) => request({ url: "teach/getTeachCenterList", method: "post", data: params });
// 答疑列表（移动端）-新版
api.getTeachCenterListNew = (params = {}) => request({ url: "teach/teachCenterListNew", method: "post", data: params });



export default api;


// WEBPACK FOOTER //
// ./src/api/index.js